import create from 'zustand'

export interface GoogleID {
    token: string | undefined
    setToken: (token: string | undefined) => void
}

const useGoogleIDStore = create<GoogleID>()((set) => ({
    token: undefined,
    setToken: (token) => set({token: token})
}))

export default useGoogleIDStore;